import { createSlice } from "@reduxjs/toolkit"

const navigationHistorySlice = createSlice({
  name: "navigationHistory",
  initialState: {
    fromRoute: { "sign-in": "", menu: "home" },
    language: 'mx',
  },
  reducers: {
    setFromRoute: (state, action) => {
      state.fromRoute = { ...state.fromRoute, ...action.payload }
    },
    clearFromRoute: (state, _) => {
      state.fromRoute = { "sign-in": "", menu: "home" }
    },
    setLanguage: (state, action) => {
      state.language = action.payload.language
    }
  },
})

export const { setFromRoute, clearFromRoute, setLanguage } = navigationHistorySlice.actions

export default navigationHistorySlice.reducer
